module.exports = __webpack_public_path__ + "img/guide_IOS.2bb1c725.png";